var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/240cddaf0efb554f856592b6a7f3ee25.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2522fa54e05111109bd1d968a4c4393a.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95bd59e5fd30983702cc4c04723f46f4.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/991332c113e7584b7aba2234a5472d20.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/afd91e821a8b23a1f758c2faa8c8e254.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f019031cd65fbf23371cd3e5754abd91.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    